<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>挂号科室</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.keshiname" placeholder="输入科室"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
		<el-button size="small" type="primary" icon="el-icon-refresh-left" @click="updepartment()">更新科室</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" 
	:data="listData" 
	 row-key="department_id"
	 :key='Math.random()'
	 :load="load"
	 :lazy = true
	 :indent=50
	 default-expand-all
	 :tree-props="{children: 'erji', hasChildren: 'sanji'}"
		
	highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" 
	style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column prop="department_name" align="left" label="科室名称" width="320">
      </el-table-column>
	  <el-table-column prop="department_id" align="center" label="科室id" width="100">
	  </el-table-column>
      </el-table-column>
      <el-table-column prop="ddxx" align="center" label="科室地址" width="160">
      </el-table-column>
      <el-table-column prop="ksfjbz" align="center" label="科室编号" width="160">
      </el-table-column>
	  
	  
    </el-table>
	
    <!-- 分页组件 -->
   <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  //import { registrationList } from '../../api/baseset'
  import { getdepartment } from '../../api/baseset'
  import { updatedepartment } from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        formInline: {
          page: 1,
          limit: 10
        },
        listData: [], //表格数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    components: {
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      getdata(param) {
        getdepartment(param)
        .then(res => {
          this.loading = false
		  //console.log(res)
         console.log(res)
          this.listData = res.data
		  console.log(this.listData)
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
         this.pageparm.pageSize = this.formInline.limit
         this.pageparm.total = res.count
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.formInline.limit = 10
        this.getdata(this.formInline)
      },
      // 重置搜索
      formReset() {
        this.formInline.userkey = '';
      },
	  load(tree, treeNode, resolve) {
	  		  console.log(treeNode);
	  		console.log(tree.sanji);
	  		console.log(tree.department_id)
	  		//if(tree.department_id > 31){
	  			resolve(tree.sanji)
	  			
	  		//}
	    
	  		
	  },
	  rowKey:function(row){
		  console.log(row)
		  
	  },
	  updepartment:function(){
		  updatedepartment()
		  .then(res => {
		    this.loading = false
		    //console.log(res)
		   console.log(res.data)
		     if(res.data.status == 1){
				 this.loading = false
				 this.$message.success('操作成功')
			 }else{
				 this.loading = false
				 this.$message.error('数据加载失败，请稍后再试！')
			 }
		  })
		  .catch(err => {
		    this.loading = false
		    this.$message.error('数据加载失败，请稍后再试！')
		  })
	  }
    }

  }
</script>

<style>
  .user-search {
    margin-top: 20px;
  }
  th .cell{
  	  text-align: center !important; 
  }
  
  .el-table_2_column_8 is-center  el-table__cell {
	   text-align: center !important; 
  }
  .el-table .el-table__cell .is-center {
      text-align: left !important;
  }
  
</style>



// WEBPACK FOOTER //
// src/views/base/updateDepartment.vue